export const UNSCOPED_PAPER_SUMMARY_USER_ID = '6bfedac0-6845-49d6-a721-667832c06041';

/**
 * Presentation-only capability check for the one account that may request a
 * summary without owning a project containing the paper. PostgreSQL RLS is
 * still the authoritative access control.
 */
export function canGenerateUnscopedPaperSummary(userId: string | null | undefined): boolean {
    return userId === UNSCOPED_PAPER_SUMMARY_USER_ID;
}

export function resolvePaperSummaryProjectId({
    canGenerateUnscoped,
    viewerOwnsProject,
    projectId,
}: {
    canGenerateUnscoped: boolean;
    viewerOwnsProject: boolean;
    projectId: string | null | undefined;
}): string | null {
    if (canGenerateUnscoped) {
        return null;
    }

    return viewerOwnsProject ? projectId || null : null;
}

export function isSummaryEligibleProjectPaper({
    relevanceClass,
    processingState,
}: {
    relevanceClass: number | null | undefined;
    processingState: string | null | undefined;
}): boolean {
    return (
        (relevanceClass === 1 || relevanceClass === 2)
        && processingState !== 'obsolete'
        && processingState !== 'rejected'
        && (processingState === null || typeof processingState === 'string')
    );
}
